export default "__VITE_ASSET__$3EP_lcc__";